export class ExportSettings {
  constructor(v: Partial<ExportSettings> = {}) {

  }
}
